var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      attrs: {
        titulo: _vm.isEditing ? "Editar Assinatura" : "Adicionar Assinatura",
        width: 1600,
        height: 1000,
        closeOutside: false
      },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c("template", { slot: "body" }, [
        _c(
          "div",
          [
            !_vm.isEditing
              ? _c(
                  "el-row",
                  {
                    staticClass: "input-row",
                    attrs: { type: "flex", align: "middle" }
                  },
                  [
                    _c("input", {
                      ref: "fileInput",
                      staticClass: "hidden-input",
                      attrs: {
                        type: "file",
                        accept:
                          "application/pdf,image/png,image/jpeg,image/jpg,image/webp"
                      },
                      on: { change: _vm.onPickFile }
                    }),
                    _c("el-input", {
                      staticClass: "flex-1",
                      attrs: {
                        placeholder: "Selecione um arquivo PDF ou imagem",
                        readonly: "readonly"
                      },
                      model: {
                        value: _vm.fileName,
                        callback: function($$v) {
                          _vm.fileName = $$v
                        },
                        expression: "fileName"
                      }
                    }),
                    _c(
                      "el-button",
                      {
                        staticClass: "bt-buscar-arquivo",
                        attrs: { icon: "el-icon-upload" },
                        on: { click: _vm.openFileDialog }
                      },
                      [_vm._v("Buscar arquivo")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "el-row",
              { staticClass: "mt-16", attrs: { gutter: 16 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 12 } },
                  [
                    _c("el-card", { attrs: { shadow: "never" } }, [
                      !_vm.isEditing
                        ? _c(
                            "div",
                            { staticClass: "btn-group" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    disabled:
                                      !_vm.renderedDataUrl || !!_vm.cropper
                                  },
                                  on: { click: _vm.initCropper }
                                },
                                [_vm._v("Ativar recorte")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    disabled: !_vm.cropper
                                  },
                                  on: { click: _vm.doCrop }
                                },
                                [_vm._v("Recortar")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "danger",
                                    disabled: !_vm.cropper
                                  },
                                  on: { click: _vm.destroyCropper }
                                },
                                [_vm._v("Cancelar")]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.croppedDataUrl
                        ? _c("div", { staticClass: "mt-24 container-card" }, [
                            _c(
                              "div",
                              { staticClass: "input-row" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "input-col",
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Nome para a assinatura:")
                                    ]),
                                    _c("el-input", {
                                      attrs: { placeholder: "Nome" },
                                      on: {
                                        input: function($event) {
                                          _vm.nomeAssinatura = $event.toUpperCase()
                                        }
                                      },
                                      model: {
                                        value: _vm.nomeAssinatura,
                                        callback: function($$v) {
                                          _vm.nomeAssinatura = $$v
                                        },
                                        expression: "nomeAssinatura"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "input-col",
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c("span", [_vm._v("Cargo:")]),
                                    _c("el-input", {
                                      attrs: { placeholder: "Cargo" },
                                      model: {
                                        value: _vm.cargoAssinatura,
                                        callback: function($$v) {
                                          _vm.cargoAssinatura = $$v
                                        },
                                        expression: "cargoAssinatura"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "input-row" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "input-col",
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Tamanho fonte do nome:")
                                    ]),
                                    _c("el-input-number", {
                                      staticClass: "num-only",
                                      attrs: {
                                        min: 1,
                                        max: 300,
                                        step: 1,
                                        "controls-position": "right"
                                      },
                                      model: {
                                        value: _vm.modelNameFontSize,
                                        callback: function($$v) {
                                          _vm.modelNameFontSize = $$v
                                        },
                                        expression: "modelNameFontSize"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "input-col",
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Tamanho fonte do cargo:")
                                    ]),
                                    _c("el-input-number", {
                                      staticClass: "num-only",
                                      attrs: {
                                        min: 1,
                                        max: 300,
                                        step: 1,
                                        "controls-position": "right"
                                      },
                                      model: {
                                        value: _vm.modelCargoFontSize,
                                        callback: function($$v) {
                                          _vm.modelCargoFontSize = $$v
                                        },
                                        expression: "modelCargoFontSize"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "input-col",
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c("span", [_vm._v("Espessura da linha:")]),
                                    _c("el-input-number", {
                                      staticClass: "num-only",
                                      attrs: {
                                        min: 1,
                                        max: 300,
                                        step: 1,
                                        "controls-position": "right"
                                      },
                                      model: {
                                        value: _vm.modelLineWidth,
                                        callback: function($$v) {
                                          _vm.modelLineWidth = $$v
                                        },
                                        expression: "modelLineWidth"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "input-row" },
                              [
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "input-col",
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Espaço acima da linha:")
                                    ]),
                                    _c("el-input-number", {
                                      staticClass: "num-only",
                                      attrs: {
                                        min: -100,
                                        max: 300,
                                        step: 1,
                                        "controls-position": "right"
                                      },
                                      model: {
                                        value: _vm.modelLineGapTop,
                                        callback: function($$v) {
                                          _vm.modelLineGapTop = $$v
                                        },
                                        expression: "modelLineGapTop"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "input-col",
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Espaço abaixo da linha:")
                                    ]),
                                    _c("el-input-number", {
                                      staticClass: "num-only",
                                      attrs: {
                                        min: 1,
                                        max: 300,
                                        step: 1,
                                        "controls-position": "right"
                                      },
                                      model: {
                                        value: _vm.modelLineGapBottom,
                                        callback: function($$v) {
                                          _vm.modelLineGapBottom = $$v
                                        },
                                        expression: "modelLineGapBottom"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-col",
                                  {
                                    staticClass: "input-col",
                                    attrs: { span: 12 }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Espaço entre nome e cargo:")
                                    ]),
                                    _c("el-input-number", {
                                      staticClass: "num-only",
                                      attrs: {
                                        min: 1,
                                        max: 300,
                                        step: 1,
                                        "controls-position": "right"
                                      },
                                      model: {
                                        value: _vm.modelTextGap,
                                        callback: function($$v) {
                                          _vm.modelTextGap = $$v
                                        },
                                        expression: "modelTextGap"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm.renderedDataUrl && _vm.isCropped
                      ? _c(
                          "el-card",
                          { staticClass: "mt-16", attrs: { shadow: "never" } },
                          [
                            _c(
                              "div",
                              { staticClass: "input-row" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content:
                                        "Use o mouse ou as setas do teclado",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("div", { staticClass: "input-col" }, [
                                      _c("span", [
                                        _vm._v(
                                          "Rotação: " +
                                            _vm._s(_vm.rotationAngle) +
                                            "°"
                                        )
                                      ]),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model.number",
                                            value: _vm.rotationAngle,
                                            expression: "rotationAngle",
                                            modifiers: { number: true }
                                          }
                                        ],
                                        staticClass: "native-slider",
                                        attrs: {
                                          type: "range",
                                          min: "-180",
                                          max: "180",
                                          step: "1"
                                        },
                                        domProps: { value: _vm.rotationAngle },
                                        on: {
                                          input: _vm.applyRotation,
                                          __r: function($event) {
                                            _vm.rotationAngle = _vm._n(
                                              $event.target.value
                                            )
                                          },
                                          blur: function($event) {
                                            return _vm.$forceUpdate()
                                          }
                                        }
                                      })
                                    ])
                                  ]
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Resetar rotação",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("el-button", {
                                      staticClass: "reset-rotation-btn",
                                      attrs: {
                                        circle: "circle",
                                        icon: "el-icon-refresh",
                                        disabled: _vm.rotationAngle === 0
                                      },
                                      on: { click: _vm.resetRotation }
                                    })
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "Excluir arquivo",
                                      placement: "top"
                                    }
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        icon: "el-icon-delete",
                                        circle: "circle"
                                      },
                                      on: { click: _vm.deleteFile }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("img", {
                              ref: "img",
                              staticClass: "pdf-image",
                              attrs: { src: _vm.renderedDataUrl }
                            })
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm.isEditing || _vm.isCropped
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _c("el-card", { attrs: { shadow: "never" } }, [
                          _c("h4", { staticClass: "preview-title" }, [
                            _vm._v("Prévia da assinatura")
                          ]),
                          _vm.finalBlobUrl
                            ? _c("div", { staticClass: "preview-container" }, [
                                _c("img", {
                                  staticClass: "preview-image",
                                  attrs: { src: _vm.finalBlobUrl }
                                })
                              ])
                            : _vm._e(),
                          _vm.finalBlobUrl
                            ? _c(
                                "div",
                                { staticClass: "footer-actions" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit("closeModal")
                                        }
                                      }
                                    },
                                    [_vm._v("Cancelar")]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "actions-right" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            icon: "el-icon-check"
                                          },
                                          on: { click: _vm.uploadToBackend }
                                        },
                                        [_vm._v("Salvar Assinatura")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isEditing && !_vm.isCropped
                  ? _c(
                      "el-col",
                      { attrs: { span: 12 } },
                      [
                        _vm.renderedDataUrl
                          ? _c("el-card", { attrs: { shadow: "never" } }, [
                              _c(
                                "div",
                                { staticClass: "input-row" },
                                [
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content:
                                          "Use o mouse ou as setas do teclado",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "input-col" }, [
                                        _c("span", [
                                          _vm._v(
                                            "Rotação: " +
                                              _vm._s(_vm.rotationAngle) +
                                              "°"
                                          )
                                        ]),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model.number",
                                              value: _vm.rotationAngle,
                                              expression: "rotationAngle",
                                              modifiers: { number: true }
                                            }
                                          ],
                                          staticClass: "native-slider",
                                          attrs: {
                                            type: "range",
                                            min: "-180",
                                            max: "180",
                                            step: "1"
                                          },
                                          domProps: {
                                            value: _vm.rotationAngle
                                          },
                                          on: {
                                            input: _vm.applyRotation,
                                            __r: function($event) {
                                              _vm.rotationAngle = _vm._n(
                                                $event.target.value
                                              )
                                            },
                                            blur: function($event) {
                                              return _vm.$forceUpdate()
                                            }
                                          }
                                        })
                                      ])
                                    ]
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "Resetar rotação",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("el-button", {
                                        staticClass: "reset-rotation-btn",
                                        attrs: {
                                          circle: "circle",
                                          icon: "el-icon-refresh",
                                          disabled: _vm.rotationAngle === 0
                                        },
                                        on: { click: _vm.resetRotation }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        content: "Excluir arquivo",
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          icon: "el-icon-delete",
                                          circle: "circle"
                                        },
                                        on: { click: _vm.deleteFile }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c("img", {
                                ref: "img",
                                staticClass: "pdf-image",
                                attrs: { src: _vm.renderedDataUrl }
                              })
                            ])
                          : _c("div", { staticClass: "empty-state" }, [
                              _c("i", {
                                staticClass: "el-icon-document empty-icon"
                              }),
                              _c("span", [
                                _vm._v(
                                  "Selecione um arquivo PDF ou imagem para extrair a assinatura"
                                )
                              ])
                            ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7908a026", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7908a026","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/seguranca/components/AppModalAdicionarAssinatura.vue
// module id = null
// module chunks = 